import styled from 'styled-components';

const Label = styled.label`
  font-weight: 500;
  color: ${props => props.theme.black};
  margin-bottom: 0.25rem;
`;

export default Label;
